import { render } from "./DocumentDisplay.vue?vue&type=template&id=9b03d628&scoped=true"
import script from "./DocumentDisplay.vue?vue&type=script&lang=js"
export * from "./DocumentDisplay.vue?vue&type=script&lang=js"

import "./DocumentDisplay.vue?vue&type=style&index=0&id=9b03d628&scoped=true&lang=css"

import exportComponent from "C:\\Users\\javon\\mgs\\RabbitsfootOperatorApps\\playerpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b03d628"]])

export default __exports__